// src/AuthContext.js
import React, { createContext, useState, useEffect } from 'react';
import { firestore, doc, getDoc } from './firebase-config';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [verifiedPlayer, setVerifiedPlayer] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check localStorage for existing verified player on mount
  useEffect(() => {
    const storedUuid = localStorage.getItem('minecraftUuid');
    if (storedUuid) {
      // Verify the UUID still exists in Firestore
      fetchPlayerData(storedUuid);
    } else {
      setLoading(false);
    }
  }, []);

  const fetchPlayerData = async (uuid) => {
    try {
      const playerRef = doc(firestore, 'players', uuid);
      const playerDoc = await getDoc(playerRef);
      
      if (playerDoc.exists()) {
        const playerData = playerDoc.data();
        setVerifiedPlayer({
          uuid: uuid,
          playerId: playerData.playerId,
          username: playerData.username,
          blocksPainted: playerData.blocksPainted,
          nameColour: playerData.nameColour,
          icon: playerData.icon,
          rankPrefix: playerData.rankPrefix,
        });
      } else {
        // UUID no longer exists, clear localStorage
        localStorage.removeItem('minecraftUuid');
        setVerifiedPlayer(null);
      }
    } catch (error) {
      console.error('Error fetching player data:', error);
      setVerifiedPlayer(null);
    } finally {
      setLoading(false);
    }
  };

  const verifyPlayer = (uuid) => {
    localStorage.setItem('minecraftUuid', uuid);
    fetchPlayerData(uuid);
  };

  const logoutPlayer = () => {
    localStorage.removeItem('minecraftUuid');
    setVerifiedPlayer(null);
  };

  return (
    <AuthContext.Provider
      value={{ 
        verifiedPlayer, 
        verifyPlayer, 
        logoutPlayer, 
        loading,
        isVerified: !!verifiedPlayer 
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};